export const getAgritechLanguage = () => {
  return localStorage.getItem("agritech-language") || "es";
};

export const getAgritechText = () => {
  const lang = getAgritechLanguage();

  return {
    lang,

    titleTagline:
      lang === "es" ? "¡El futuro nace verde!" : "The future starts green!",

    playGame: lang === "es" ? "Jugar" : "Play Game",
    tutorial: "Tutorial",
    options: lang === "es" ? "Opciones" : "Options",
    credits: lang === "es" ? "Créditos" : "Credits",
    leaderboard: lang === "es" ? "Clasificación" : "Leaderboard",

    gameStart: lang === "es" ? "¡Comienza!" : "Game Start !",
    tutorialStart: lang === "es" ? "¡Tutorial!" : "Tutorial !",
    finish: lang === "es" ? "¡Final!" : "Finish !",

    optionsTitle: lang === "es" ? "Opciones" : "Options",
    language: lang === "es" ? "Idioma" : "Language",
    english: lang === "es" ? "Inglés" : "English",
    spanish: "Español",
    musicVolume: lang === "es" ? "Volumen de música" : "Music Volume",
    effectsVolume: lang === "es" ? "Volumen de efectos" : "Effects Volume",
    return: lang === "es" ? "Volver" : "Return",

    challengeTitle:
      lang === "es" ? "Desafío de biofertilizantes" : "Biofertilizer Challenge",
    finalAnswer: lang === "es" ? "¿Respuesta final?" : "Final Answer?",
    continue: lang === "es" ? "Continuar" : "Continue",
    correct: lang === "es" ? "¡Correcto!" : "Correct!",
    incorrect: lang === "es" ? "Incorrecto." : "Incorrect!",
    powerStored: lang === "es" ? "poder guardado" : "power stored",

    returnMain:
      lang === "es"
        ? "Volver a la pantalla principal"
        : "Return to Main Screen",
    congrats: lang === "es" ? "¡MUY BIEN!" : "CONGRATS!",
  };
};
